var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-overlay align-center d-flex jc-center fd-row p-flex t-0 r-0 b-0 l-0"},[_c('div',{staticClass:"pop-container d-flex p-flex a-center jc-center"},[_c('v-preloader')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }